import React from "react";
import { Reveal } from "@/components/Reveal";
import { STANDARDS, IMAGES } from "@/data/content";

export const Standard = () => {
  return (
    <section id="standard" className="py-28 md:py-40 bg-warmwhite" data-testid="standard-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20">
          <div className="lg:col-span-5 lg:sticky lg:top-28 lg:self-start">
            <Reveal>
              <p className="overline text-champagne mb-6">The Standard of Care</p>
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.08] text-charcoal">
                Luxury customers buy standards, not cleaning.
              </h2>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="img-frame group mt-12 hidden lg:block">
                <img src={IMAGES.standard} alt="Elegant marble bathroom" className="w-full aspect-[4/5] object-cover" />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <div className="divide-y divide-stone/70 border-t border-stone/70">
              {STANDARDS.map((s, i) => (
                <Reveal key={s.n} delay={i * 0.08}>
                  <div className="py-10 md:py-12 flex gap-8 md:gap-12 group" data-testid={`standard-${i}`}>
                    <span className="font-serif text-4xl md:text-5xl text-stone group-hover:text-champagne transition-colors duration-500">
                      {s.n}
                    </span>
                    <div>
                      <h3 className="font-serif text-2xl md:text-3xl text-charcoal font-normal">{s.title}</h3>
                      <p className="mt-4 text-charcoal/65 leading-relaxed max-w-lg text-[15px]">{s.body}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
